import React from 'react';
import styled from 'styled-components';

import v from '../../styles/Variables';

interface Props {
  title: string;
}

const LabelText = ({ title }: Props) => (
  <Label htmlFor="nwc--button-group" className="nwc--button-group-title-text">
    {title}
  </Label>
);

export default LabelText;

/* label */
const Label = styled.label`
  color: ${v.colors.dark};
  font-size: 18px;
  margin-bottom: 5px;
  display: inline-block;
`;
